import {css} from 'lit';
export const styles = css`:host {
  /* stylelint-disable-next-line length-zero-no-unit */
  --gap: 0px; /* Unit has to be specified as we are using CSS calc function */
  --max-height: none;
  --header-margin: 16px;
  --footer-margin: 16px;

  display: block;
}

header,
footer {
  display: flex;
  align-items: center;
}

header {
  margin-bottom: var(--header-margin);
}

footer {
  margin-top: var(--footer-margin);
}

slot[name='right']::slotted(*),
slot[name='bottom-right']::slotted(*) {
  margin-left: auto;
}

.section > slot::slotted(*:not(:first-child)) {
    margin-top: var(--gap);
  }

:host([overflow='true']) .section > slot {
    display: block;
    max-height: var(--max-height);
    overflow-x: auto;
  }

:host([horizontal='true']) .section > slot {
    display: flex;
    flex-wrap: wrap;
    margin-top: -16px;
    margin-bottom: -16px; /* Overflow cut elements */
    padding-top: 16px;
    padding-bottom: 16px;
  }

/* Overflow cut elements */

:host([horizontal='true']) .section > slot::slotted(*) {
      margin-bottom: var(--gap);
    }

:host([horizontal='true']) .section > slot::slotted(*:not(:first-child)) {
      margin-top: 0;
    }

:host([horizontal='true']) .section > slot::slotted(*:not(:last-child)) {
      margin-right: var(--gap);
    }

:host([horizontal='true']) footer {
    margin-top: calc(var(--footer-margin) - var(--gap));
  }

:host([horizontal='true'][overflow='true']) {
  padding-right: 0;
}

:host([horizontal='true'][overflow='true']) .section > slot {
    flex-wrap: nowrap;
    margin-left: calc(var(--page-padding-x) * -1); /* Overflow cut elements */
    margin-right: calc(var(--page-padding-x) * -1); /* Overflow cut elements */
    padding-left: var(--page-padding-x);
    padding-right: var(--page-padding-x);
  }

:host([horizontal='true'][overflow='true']) .section > slot::slotted(*) {
      margin-bottom: 0;
    }

:host([horizontal='true'][overflow='true']) footer {
    margin-top: 16px;
    margin-top: var(--footer-margin, 16px);
  }

:host([gap='sm']) {
  --gap: 4px;
}

:host([gap='md']) {
  --gap: 8px;
}

:host([gap='lg']) {
  --gap: 16px;
}

:host([gap='xl']) {
  --gap: 32px;
}
`;
export default styles;
